import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-invoice-range',
  templateUrl: './invoice-range.component.html',
  styleUrls: [],
  standalone: false
})
export class InvoiceRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
